import { createServerFn } from "@tanstack/react-start";
import { t } from "../i18n/en";

export const getPublicChart = createServerFn({ method: "GET" })
  .validator((identifier: string) => {
    if (typeof identifier !== "string" || !/^[a-zA-Z0-9_-]{3,80}$/.test(identifier)) {
      throw new Error(t("ui.copy_invalid_chart_link_ae05a564"));
    }
    return identifier;
  })
  .handler(async ({ data }) => {
    const { readPublicChart } = await import("../server/public-chart");
    return readPublicChart(data);
  });
